import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { UserForm } from '@/components/forms/UserForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function CreateUserPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()

  const handleSuccess = () => {
    navigate('/user-management/users')
  }

  const handleCancel = () => {
    navigate('/user-management/users')
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create New User</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new user account with role assignments
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <UserForm onSuccess={handleSuccess} onCancel={handleCancel} />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


